export default __webpack_public_path__ + "static/media/V4.664d6642.svg";